export default __webpack_public_path__ + "static/mobile-mytasks-3354b543c62d7ee9f0dc9a254b9c8db0.png";